/**
 * The admin-only rail counts, out of Sidebar.tsx (which sat at exactly 500 lines):
 * #1331 Part 3's unread WhatsApp threads (moved verbatim) and the Data issues inbox's open
 * issues (GET /admin/data-issues/count, polled every 60 s; every decision invalidates it).
 */
import { useQuery } from '@tanstack/react-query'
import type { User } from '@/types'
import { getUserRoleFlags } from './navigationSections'
import { whatsappInboxApi } from '@/services/api/whatsapp-inbox.api'
import { useWhatsAppInboxLive, WA_INBOX_QUERY_KEY } from '@/hooks/useWhatsAppInboxLive'
import { adminDataIssuesApi, DATA_ISSUES_QUERY_KEY } from '@/services/api/admin-data-issues.api'

export function useAdminNavCounts(user: User | null | undefined): { whatsappUnreadCount: number; dataIssuesOpenCount: number } {
  const enabled = !!user && getUserRoleFlags(user).isAdmin
  const { data: whatsappUnreadCount = 0 } = useQuery({
    queryKey: [...WA_INBOX_QUERY_KEY, 'unread-count'],
    queryFn: () => whatsappInboxApi.unreadCount(),
    refetchInterval: 30000,
    enabled,
  })
  useWhatsAppInboxLive(enabled)
  const { data: dataIssuesOpenCount = 0 } = useQuery({
    queryKey: [...DATA_ISSUES_QUERY_KEY, 'count'],
    queryFn: () => adminDataIssuesApi.count(),
    refetchInterval: 60_000,
    enabled,
  })
  return { whatsappUnreadCount, dataIssuesOpenCount }
}
